import React, { useState, useEffect, createRef } from "react";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import Grid from "@material-ui/core/Grid";

import axios from "axios";
import "../App.css";

function MessagesBox(props) {
  const [sender, setSender] = useState("loading");
  const messagesEndRef = createRef();


  useEffect(() => {
    const link = `/user/${localStorage.getItem("currentProfile")}`;

    axios
      .get(link)
      .then((res) => {
        setSender(res.data.name);
        console.log(res.data);
        console.log(sender);
      })
      .catch((err) => {
        console.log(err);
      });

    scrollToBottom();

  }, []);

  dayjs.extend(relativeTime);

  const scrollToBottom = () => {
    messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div>
      <h1>Chat</h1>
      <Grid className="shadow"
        style={{
          backgroundColor: "#f2f2f2",
          borderRadius: 8,
          // boxShadow: "5px 5px #d4d4d4",
          // borderStyle: "solid",
          // borderColor: "#9e9e9e",
          height: 600,
          overflowY: "scroll",
        }}
      >
        {props.messages.map((message, i) => (
          <div key={i}>
            {localStorage.getItem("user") === message.senderId ? (
              <Grid container style={{ flex: 1, justifyContent: "flex-end" }}>
                <Grid style={{ flex: 0.4, justifyContent: "flex-end" }}>
                  <p className="border"
                    style={{
                      backgroundColor: "white",
                      borderTopLeftRadius: 8,
                      borderTopRightRadius: 8,
                      marginBottom: -20,
                      width: 50,
                      padding: 4,
                    }}
                  >
                    You
                  </p>
                  <h2
                    style={{
                      backgroundColor: "#3f51b5",
                      color: "white",
                      borderBottomLeftRadius: 8,
                      borderTopRightRadius: 8,
                      borderBottomRightRadius: 8,
                      marginRight: 12,
                      padding: 8,
                    }}
                  >
                    {message.body}
                  </h2>
                  <p style={{ marginTop: -20, padding: 4 }}>
                    {dayjs(message.createdAt).fromNow()}
                  </p>
                </Grid>
              </Grid>
            ) : (
              <Grid container style={{ flex: 1 }}>
                <Grid style={{ flex: 0.4, justifyContent: "flex-end" }}>
                  <p className="border"
                    style={{
                      backgroundColor: "white",
                      borderTopLeftRadius: 8,
                      borderTopRightRadius: 8,
                      marginBottom: -20,
                      width: 150,
                      padding: 4,
                      marginLeft: 12,
                    }}
                  >
                    {sender}
                  </p>
                  <h2 className="border"
                    style={{
                      backgroundColor: "white",
                      color: "black",
                      borderBottomLeftRadius: 8,
                      borderTopRightRadius: 8,
                      borderBottomRightRadius: 8,
                      marginLeft: 12,
                      padding: 8,
                    }}
                  >
                    {message.body}
                  </h2>
                  <p style={{ marginTop: -20, padding: 4 }}>
                    {dayjs(message.createdAt).fromNow()}
                  </p>
                </Grid>
              </Grid>
            )}
          </div>
        ))}
        <div ref={messagesEndRef} />
      </Grid>
    </div>
  );
}

export default MessagesBox;
